import {BsrsFlowFeature} from "../../features/bsrs";

const BsrsPage = () => <BsrsFlowFeature />

export default BsrsPage;
